import { Navigate } from "react-router-dom";
import { Subtree, useObserver, useSubtree } from "subtree.js/react";
import { pick } from "trunk.js";
import { AppState } from "../../app-controller";
import type { AppDeps } from "../../app-deps";
import { ProfileUnavailable } from "../../components/ProfileUnavailable";
import { DEFAULT_ROUTE } from "../../core/primitives/routes";
import { RegisterController } from "./register-controller";
import { RegisterPage } from "./register-page";

/**
 * The Firebase account exists but its profile could not be loaded; submitting
 * the form again would only fail on "email already in use".
 */
export function RegisterRoute({ deps }: { deps: AppDeps }) {
  const state = useSubtree(AppState);
  const observer = useObserver();
  const gate = observer.watch(state.gate);
  if (gate === "signedIn") return <Navigate to={DEFAULT_ROUTE} replace />;
  if (gate === "profileFailed") return <ProfileUnavailable />;
  return (
    <Subtree
      key="register"
      controller={() => new RegisterController(pick(deps, "client", "session", "profileRepository"))}
    >
      <RegisterPage />
    </Subtree>
  );
}
